<template>
  <div class="wrapper">
    <div class="effective">
      <!-- 左半部分 -->
      <div class="left-effective">
        <div class="">
          <div class="title-effective">
            企业名称：
          </div>
          <div class="context">
             {{WarnInfoData.BLCompanyName}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            起始时间：
          </div>
          <div class="context">
            {{WarnInfoData.BLBusinessStartDate}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            营业执照
          </div>
          <div class="" style="  position: relative;left: -20px;top: -40px;">
            <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title=""  :BLPhotoURL="WarnInfoData.BLPhotoURL"></CommonuploadEnclosure>
          </div>
        </div>
      
      </div>
      <!--右半部分-->
      <div class="right-effective">
        <div class="">
          <div class="title-effective">
            统一社会信用代码：
          </div>
          <div class="context">
            {{WarnInfoData.BLUnifiedSocialCreditCode}}
          </div>
        </div>
        <div class="border-context" >
          <div class="title-effective" style="min-width: 126px;">
            失效时间：
          </div>
          <div class="context">
            {{WarnInfoData.BLBusinessEndDate}}
          </div>
        </div>
      </div>
    </div>
    <div class="reject-Overdue">
      <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
      <span v-html="$options.filters.filters2(WarnInfoList.StringMessage)">
      </span>
    </div>
  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
      type: undefined
    },
    WarnInfoList: {
      type: Object
    }
  },
  filters: {
    filters2(arg) {
      let args = null
      if (arg) {
        args = arg.replace('<span style=\"\"color: #E71D43\"\">', '<span style="color: #E71D43">')
      }
      return args;
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>